
import "@sparta.home-loans.modules/assumptions-header-banner-module/dist/styles.css"
import "@sparta.home-loans.modules/assumptions-content-module/dist/styles.css"
import "@sparta.home-loans.modules/assumptions-content-list-module/dist/styles.css"
import "@sparta.home-loans.modules/assumptions-table-four-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es6.js"
import jsUtility from "@sparta.home-loans.utilities/js-utility/dist/es6.js"

import "@sparta.home-loans.modules/assumptions-header-banner-module/dist/es6.js"
import "@sparta.home-loans.modules/assumptions-content-module/dist/es6.js"
import "@sparta.home-loans.modules/assumptions-content-list-module/dist/es6.js"
import "@sparta.home-loans.modules/assumptions-content-list-module/dist/es6.js"
import "@sparta.home-loans.modules/assumptions-table-four-module/dist/es6.js"
import "@sparta.home-loans.modules/assumptions-content-module/dist/es6.js"
import "@sparta.home-loans.modules/assumptions-content-list-module/dist/es6.js"
import "@sparta.home-loans.modules/assumptions-content-list-module/dist/es6.js"
import "@sparta.home-loans.modules/assumptions-content-module/dist/es6.js"
import "@sparta.home-loans.modules/assumptions-content-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
secureLinkUtility.run()
  console.log('after - execute boot functions')
})();
